import React, { useState } from "react";
//import { useSelector } from "react-redux";
import Image from "../Image/Image";
import Popup from "../popup";
//import { appNavigateTo } from '../../../store/actions/navActions';
//import { useDispatch } from 'react-redux';
const Header = ({ classes , headeLogo}) => {
    const [helpPopup, setHelpPopup] = useState(false);
    //const state = useSelector((state) => state.AppNav);
    //const dispatch = useDispatch();
    //const currentpage = state?.goTo;
    return (
        <div className={classes.FlexOuter}>
            <div className={classes.Logos}>
                { headeLogo!=="" && (<Image filename={headeLogo} ext="png" alt="" height="45px" width="45px" />) } 
                <Image filename={"Sprint"} ext="png" renditions={["2x"]} alt="" />
                {/* <span className={classes.VerticalLine}></span> */}
                {/* <Image
                    className={classes.CompLogo}
                    filename={"Group167"}
                    ext="png"
                    renditions={["2x"]}
                    alt=""
                /> */}
            </div>
            <div className={classes.NavRight}>
                {/* {(currentpage==='landingPage'||getSection(currentpage) === "professionalDetails" ||
                     getSection(currentpage) === "personalDetails") && <span onClick={() => {
                    dispatch(appNavigateTo({goTo: "changecard", previouspage: currentpage}, 'APP_NAVIGATE_TO'))
                    }}>
                    <Image
                        filename={"Path671"}
                        ext="png"
                        renditions={["2x"]}
                        alt=""
                    />
                    <label className={classes.BackButton}>Explore More Cards</label>
                </span>} 
                <span onClick={() => { dispatch(appNavigateTo({ goTo: "helpcenter", previouspage: currentpage }, 'APP_NAVIGATE_TO')) }}>
                    <Image
                        filename={"Group517"}
                        ext="png"
                        renditions={["2x"]}
                        alt=""
                    />
                    <label className={classes.HelpButton}>Help</label>
                </span>*/}
                {/* <span>
                    <Image
                        filename={"Group380"}
                        ext="png"
                        renditions={["2x"]}
                        alt=""
                    />
                    <label className={classes.ChangeCard}>Change Card</label>
                </span> */}
            </div>
            {helpPopup && (<Popup
                content={
                    <>
                        <div>
                            <h3 className={classes.TermAndConditionHeading}>Help</h3>
                            <p className={classes.TermAndConditionText}>
                                What is Lorem Ipsum? Lorem Ipsum is simply dummy text of
                                the printing and typesetting industry. Lorem Ipsum has
                                been the industry's standard dummy text ever since the
                                1500s, when an unknown printer took a galley of type and
                                scrambled it to make a type specimen book. It has survived
                                not only five centuries, but also the leap into electronic
                                typesetting, remaining essentially unchanged. It was
                                popularised in the 1960s with the release of Letraset
                                sheets containing Lorem Ipsum passages, and more recently
                                with desktop publishing software like Aldus PageMaker
                                including versions of Lorem Ipsum.
                            </p>
                        </div>
                    </>
                }
                filename={"arrow_forward_black_24dp"}
                ext={"png"}
                renditions={["2x"]}
                handleClose={() => { setHelpPopup(!helpPopup) }}
                buttonLabel="Close"
            />)}
        </div>
    )
}

export default Header;